import { Box, Button, Typography } from "@mui/material";
import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import { skipToken } from "@reduxjs/toolkit/query";
import { useState } from "react";
import { Section } from "../../../models/Section";
import { Selection } from "../../../models/Selection";
import { planoAPI } from "../../../redux/features/cache";
import { useAppSelector } from "../../../redux/store";
import FormMagasin from "../../planogramme/components/Forms/FormMagasin";
import { MagasinForm } from "./MagasinForm";
import { ModificationSection } from "./ModificationSection";
import { ModificationSelection } from "./ModificationSelection";
import SelectionForm from "./SelectionForm";

interface WrapperModificationProps {
  section: Section | undefined;
  handleClose: any;
}

export const WrapperModification = (props: WrapperModificationProps) => {
  const d_inv026 = useAppSelector((state) => state.appState.d_inv026);

  const sectionApi = planoAPI.endpoints.getSection.useQuery(
    props.section?.plans_seq.toString() ?? skipToken,
    { refetchOnMountOrArgChange: true }
  );

  const selections = planoAPI.endpoints.getSelections.useQuery(
    props.section?.plans_seq ? {section: props.section?.plans_seq} : skipToken,
    {refetchOnMountOrArgChange: true}
  )

  const [showAddSelection, setShowAddSelection] = useState<boolean>(false);
  const [showAddStore, setShowAddStore] = useState<boolean>(false);
  const [selected, setSelected] = useState<number>(0);

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  return (
    <>
      <Typography
        variant="h5"
        sx={{ pb: 1, pl: 1, color: "#007bff" }}
      >
        Section
      </Typography>
      {sectionApi.data && (
        <ModificationSection
          section={sectionApi.data}
          handleClose={props.handleClose}
        />
      )}
      <Box sx={{ width: "100%", mt: 2 }}>
        <TabStrip
          selected={selected}
          onSelect={handleSelect}
        >
          <TabStripTab title="Selections">
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                sx={{
                  width: "300px",
                  borderRadius: "30px",
                  mb: 4,
                  backgroundColor: "#007bff",
                }}
                onClick={() => setShowAddSelection(true)}
                disabled={!d_inv026.canAdd}
              >
                {" "}
                Ajouter une sélection
              </Button>
            </Box>
            {showAddSelection && (
              <SelectionForm
                plans_seq={sectionApi.data?.plans_seq}
                setAddSelection={setShowAddSelection}
              />
            )}
            {selections.data?.map((selection: Selection) => (
              <ModificationSelection selection={selection} />
            ))}
          </TabStripTab>
          <TabStripTab title="Magasins">
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                sx={{
                  width: "300px",
                  borderRadius: "30px",
                  mb: 4,
                  backgroundColor: "#007bff",
                }}
                onClick={() => setShowAddStore(true)}
                disabled={!d_inv026.canAdd}
              >
                {" "}
                Ajouter un magasin
              </Button>
            </Box>
            {showAddStore && (
              <Box>
                <MagasinForm
                  plansSeq={sectionApi.data?.plans_seq}
                  setOpen={setShowAddStore}
                  canDelete={d_inv026.canDelete}
                />
              </Box>
            )}
            {sectionApi.data?.secMagasin.map((e, i) => (
              <FormMagasin
                data={e}
                key={e.mag_num}
              />
            ))}
          </TabStripTab>
        </TabStrip>
      </Box>
    </>
  );
};
